import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import './Tabs.scss';

function TabPanel(props) {
  const { children, value, index, name, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${name}-tabpanel-${index}`}
      aria-labelledby={`${name}tab-${index}`}
      {...other}
      style={{ marginTop: '15px' }}
      className={className}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#ffffff',
    color: '#000',
    marginTop: '35px'
  }
}));

const CustomizedTabs = props => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const { name, className } = props;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="on"
        style={{ borderBottom: '1px solid #CCCCCC' }}
      >
        {props.data.map(i => (
          <Tab
            style={{ minWidth: 'fit-content' }}
            key={i.title}
            label={i.title}
            id={`${name}-${i.id}`}
            aria-controls={`${name}-${i.id}`}
          />
        ))}
      </Tabs>
      {props.data.map((i, index) => (
        <TabPanel
          key={i.title}
          value={value}
          index={index}
          name={name}
          className={className}
        >
          {i.content}
        </TabPanel>
      ))}
    </div>
  );
};

export default CustomizedTabs;
